module.exports = __webpack_public_path__ + "static/media/java.b1c7330c.svg";